import { DispatchSummaries } from "~/components/admin/dispatch/summaries";
import PageMeta from "~/components/common/meta";

export const ScreenDispatchSummaries = () => {
  return (
    <>
      <PageMeta
        title="Dispatch Summaries | Art Handler"
        description="Dispatch Summaries"
      />
      <DispatchSummaries />
    </>
  );
};
